import { useProjectContext } from '@/context';
import { useUserManagement } from '@/context/UserManagementContext';
import { Tooltip } from 'primereact/tooltip';
import { BsDiagram3, BsFolder, BsGearFill } from 'react-icons/bs';
import { NavLink } from 'react-router';
import AccountButton from './AccountButton';
import { BsShieldLock } from 'react-icons/bs';

const BottomNavBar = () => {
  const { selectedProjectName } = useProjectContext();
  const { isAdmin, isChecking } = useUserManagement();

  const projectIcon = (
    <div className='relative'>
      <BsFolder className='w-5 h-5' />
      <BsGearFill className='w-3 h-3 absolute bottom-0 right-[2px]' />
    </div>
  );

  return (
    <nav className='flex flex-col gap-4'>
      <Tooltip target='.tooltip-message' />

      <NavLink
        to='/workflows'
        className={({ isActive }) =>
          `p-3 rounded-lg tooltip-message theme-transition group relative
           ${
             isActive
               ? 'bg-primary text-primary-foreground shadow-md border-2 border-border'
               : 'hover:bg-accent hover:text-accent-foreground'
           }`
        }
        data-pr-tooltip='Workflows'
      >
        <BsDiagram3 className='w-5 h-5' />
        <div className='absolute left-full ml-2 w-2 h-2 bg-primary rounded-full opacity-0 group-hover:opacity-100 transition-opacity' />
      </NavLink>

      <NavLink
        to='/projects'
        className={({ isActive }) =>
          `p-3 rounded-lg tooltip-message theme-transition group relative
           ${
             isActive
               ? 'bg-primary text-primary-foreground shadow-md border-2 border-border'
               : 'hover:bg-accent hover:text-accent-foreground'
           }`
        }
        data-pr-tooltip={`${selectedProjectName}`}
      >
        {projectIcon}
        <div className='absolute left-full ml-2 w-2 h-2 bg-primary rounded-full opacity-0 group-hover:opacity-100 transition-opacity' />
      </NavLink>

      {!isChecking && isAdmin && (
        <NavLink
          to='/admin/user-management'
          className={({ isActive }) =>
            `p-3 rounded-lg tooltip-message theme-transition group relative
             ${
               isActive
                 ? 'bg-primary text-primary-foreground shadow-md border-2 border-border'
                 : 'hover:bg-accent hover:text-accent-foreground'
             }`
          }
          data-pr-tooltip='Admin Panel'
        >
          <BsShieldLock className='w-5 h-5' />
          <div className='absolute left-full ml-2 w-2 h-2 bg-primary rounded-full opacity-0 group-hover:opacity-100 transition-opacity' />
        </NavLink>
      )}

      <AccountButton />
    </nav>
  );
};

export default BottomNavBar;
